import { useUser } from '~/modules/auth/hooks/useUser';

import { useHasLabelWithDdexEnabled } from '../api/queries/useHasLabelWithDdexEnabled';

export const useDdexAccess = () => {
  const { hasPermission } = useUser();

  const hasViewPermission = hasPermission('DDEX.VIEW');

  const { hasLabelWithDdexEnabled, isLoading } = useHasLabelWithDdexEnabled({
    enabled: hasViewPermission,
  });

  return {
    hasDdexAccess: hasViewPermission && !!hasLabelWithDdexEnabled,
    isLoading,
  };
};
